export const Theme = {
  colors: {
    white: '#FFFFFF',
    black: '#000000',
    red: '#E00034',
    redAlpha: '#E0003433',
    redDark: '#B0002A',
    redDarkAlpha: '#B0002A33',
    purple: '#6F5091',
    purpleAlpha: '#6F509133',
    purpleDark: '#40334E',
    purpleDarkAlpha: '#40334E59',
    greyHover: '#F1F1F1',
    greyLight: '#D9D9D6',
    greyMedium: '#A6A6A3',
    greyDark: '#63666A',
    greyDarkAlpha: '#63666ABF',
    blueLight: '#3399CC',         // Azul más claro (derivado suavemente del base)
    blueLightAlpha: '#3399CC59',  // 35% opacidad (hex 59)
    blueMedium: '#00549F',        // Tu color base
    blueMediumAlpha: '#00549F33', // 20% opacidad (hex 33)
    blueDark: '#003B70',
    blueGrey: '##3B3F5C',
    blueGreyAlpha: '#52607959',
    green: '#3F9C35',
    greenAlpha: '#3F9C3533',
    yellow: '#FCD600',
    yellowAlpha: '#FCD6004D',
    orange: '#FF9800',
    orangeAlpha: '#FF980033'
  },
  shadows: {
    depth1: '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
    depth2: '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
    depth3: '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)',
    depth4: '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
    depth5: '0px 6px 6px -3px rgba(0,0,0,0.2), 0px 10px 14px 1px rgba(0,0,0,0.14), 0px 4px 18px 3px rgba(0,0,0,0.12)'
  },
  typography: {
    heading1: '34px',
    heading2: '30px',
    heading3: '26px',
    heading4: '23px',
    heading5: '19px',
    heading6: '15.5px',
    subHeading: '14.7px',
    bodyText: '13.9px',
    smallText: '13.9px',
    captionText: '13.1px'
  }
};

// MEDIA QUERYS

// Value         |0px     600px    960px    1280px   1920px
// Key           |xs      sm       md       lg       xl
// Screen        |--------|--------|--------|--------|-------->
// Range         |   xs   |   sm   |   md   |   lg   |   xl